var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"switch ml-2"},[_c('toggle-button',{attrs:{"width":40,"labels":false},on:{"change":_vm.onChangeEventHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }